import axios from 'axios'
import { PageDataResponse ,PageResponse,DataObjectResponse, DataArrayResponse } from '../models/PageResponse'
import { Parameter,QueryDataModel,RequestRemoveCarton,RequestDetail , 
    RequestUpdateStatus  ,DataNote,CartonList, UpdateApproval, UpdateRemoveStorage} from '../models'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL

export default class RemoveCartonService
{
    protected headers = {
        'Content-Type': 'application/json',
        'Authorization': "",
        'X-XSRF-TOKEN': ""
    }
    protected token = ""
    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                'X-XSRF-TOKEN': ""
            }
        }
        
    }
    
    async GetRequest(id:number ){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<DataObjectResponse<RequestDetail>>(`${apiUrl}/v1/remove/request?id=${id}`,{}, options )
        
        return data;
    }

    async GetDetail(id:number ){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<DataObjectResponse<RequestDetail>>(`${apiUrl}/v1/remove/detail?id=${id}`,{}, options )
        
        return data;
    }

    async GetCollectDetail(id:number ){
        if(!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.post<DataObjectResponse<RequestDetail>>(`${apiUrl}/v1/remove/collectdetail?id=${id}`,{}, options )
        
        return data;
    }

    async GetCartonList(id:number ){
        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.get<DataArrayResponse<CartonList>>(`${apiUrl}/v1/remove/cartonlist?id=${id}`, options )
        
        return data;
    }
    
    async GetNote(id:number ){
        if(!this.token) return null
        let options = {
                headers:this.headers
            }
        
        const { data }  = await axios.get<DataArrayResponse<DataNote>>(`${apiUrl}/v1/remove/note?id=${id}`, options )
        
        return data;
    }

    async Search(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageDataResponse<QueryDataModel>>(`${apiUrl}/v1/remove/search`,JSON.stringify(parameter),options )
        return data;
    }

    async Searchdraft(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageDataResponse<QueryDataModel>>(`${apiUrl}/v1/remove/searchdraft`,JSON.stringify(parameter),options )
        return data;
    }

    async SearchApprover(parameter: Parameter) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers,
        }
        const { data }   = await axios.post<PageDataResponse<QueryDataModel>>(`${apiUrl}/v1/remove/search/approver`,JSON.stringify(parameter),options )
        return data;
    }

    async Create(request: RequestRemoveCarton) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/remove/create`,JSON.stringify(request),options )
        return data;
    }


    async Update(request: RequestRemoveCarton) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/remove/update`,JSON.stringify(request),options )
        return data;
    }

    async UpdateAdmin(request: UpdateRemoveStorage) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/remove/admin/update`,JSON.stringify(request),options )
        return data;
    }

    async UpdateApproval(request: UpdateApproval) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/remove/approval/update`,JSON.stringify(request),options )
        return data;
    }

    async UpdateStatus(requestUpdateStatus: RequestUpdateStatus) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/remove/status/update`,JSON.stringify(requestUpdateStatus),options )
        return data;
    }

    async DeleteCarton(ids: number[]) {
        if (!this.token) return null

        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken

        let options = {
            headers:this.headers
        }
        const { data }   = await axios.post<PageResponse>(`${apiUrl}/v1/remove/deletecarton`,JSON.stringify(ids),options )
        return data;
    }

}